import { put, call, takeEvery } from 'redux-saga/effects'
import Urls from '../../utils/urlStrings'
import { MICROSERVICES } from '../../utils/constants'
import {
  SIGNIN_USER,
  USER_SIGNIN_SUCCESS,
  USER_SIGNIN_FAILED,
  SIGNOUT_USER,
  USER_SIGNOUT_SUCCESS,
  USER_SIGNOUT_FAILED,
  GET_CURRENT_USER,
  GET_CURRENT_USER_SUCCESS,
} from '../../constants/actionTypes'
import service from '../../utils/service'
import {
  setToken,
  setSessionId,
  getSessionId,
} from '../../utils/helper'
import _ from 'lodash'
import { removeLocalStorage } from '../../utils/localStorage'
import axios from 'axios'

const signInWithDetailsRequest = async (payload) =>
  await axios.post(Urls.getApiUrl(`application/login`, MICROSERVICES.SESSIONMANAGER), { ...payload })
    .then((authUser) => authUser)
    .catch((error) => error)

const signOutCurrentUserRequest = async (payload) =>
  await service.delete(Urls.getApiUrl(`application/logout/${getSessionId()}`, MICROSERVICES.SESSIONMANAGER))
    .then(logOutData => logOutData)
    .catch(error => error)

const getCurrentUserRequest = async () =>
  await service.get(Urls.getApiUrl(`application/user_info`, MICROSERVICES.SESSIONMANAGER))
    .then((currentUserData) => currentUserData)
    .catch((error) => error)

function* signInUserWithDetails({ payload }) {
  try {
    const response = yield call(signInWithDetailsRequest, {
      username: payload.emailId,
      password: payload.password,
    })
    const { status, data } = response
    if (status === 200) {
      setToken(data.data['token'])
      setSessionId(data.data['session_id'])
      yield put({ type: USER_SIGNIN_SUCCESS, payload: data.data })
    } else {
      yield put({ type: USER_SIGNIN_FAILED })
    }
  } catch (error) {
    yield put({ type: USER_SIGNIN_FAILED })
  }
}

function* signOutCurrentUser() {
  try {
    const response = yield call(signOutCurrentUserRequest, {})
    const { status } = response
    if (status === 200) {
      removeLocalStorage('auth')
      removeLocalStorage('session_id')
      yield put({ type: USER_SIGNOUT_SUCCESS })
    } else {
      yield put({ type: USER_SIGNOUT_FAILED })
    }
  } catch (error) {
    yield put({ type: USER_SIGNOUT_FAILED })
  }
}

function* getCurrentUserWithToken({ payload }) {
  try {
    const response = yield call(getCurrentUserRequest, payload)
    const { status, data } = response
    if (status === 200) {
      yield put({ type: GET_CURRENT_USER_SUCCESS, payload: data.data })
    } else {
    }
  } catch (error) {
    console.debug(error)
  }
}

export function* signInWithDetails() {
  yield takeEvery(SIGNIN_USER, signInUserWithDetails)
}

export function* signOutUser() {
  yield takeEvery(SIGNOUT_USER, signOutCurrentUser)
}

export function* getCurrentUser() {
  yield takeEvery(GET_CURRENT_USER, getCurrentUserWithToken)
}
